var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47487 11.2322L11.5 1.20711V24.7929L1.47487 14.7678C0.498563 13.7915 0.498564 12.2085 1.47487 11.2322Z",
    fill: "white",
    stroke: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipArrowLeft);
export default __webpack_public_path__ + "static/media/TooltipArrowLeft.d7aab7e00e9299a430d54f07e5b9e897.svg";
export { ForwardRef as ReactComponent };